var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudioMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#D1D8DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H10C9.86739 11 9.74021 11.0527 9.64645 11.1464C9.55268 11.2402 9.5 11.3674 9.5 11.5V20C9.5 20.2652 9.60536 20.5196 9.79289 20.7071C9.98043 20.8946 10.2348 21 10.5 21H21.5C21.7652 21 22.0196 20.8946 22.2071 20.7071C22.3946 20.5196 22.5 20.2652 22.5 20V11.5C22.5 11.3674 22.4473 11.2402 22.3536 11.1464C22.2598 11.0527 22.1326 11 22 11ZM16 16.3219L11.2856 12H20.7144L16 16.3219ZM14.1694 16L10.5 19.3631V12.6369L14.1694 16ZM14.9094 16.6781L15.6594 17.3687C15.7516 17.4534 15.8723 17.5004 15.9975 17.5004C16.1227 17.5004 16.2434 17.4534 16.3356 17.3687L17.0856 16.6781L20.7106 20H11.2856L14.9094 16.6781ZM17.8306 16L21.5 12.6363V19.3638L17.8306 16Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioMail);
export default __webpack_public_path__ + "static/media/studioMail.c2771cd8173e75484bb184bbf1d47223.svg";
export { ForwardRef as ReactComponent };